export default {
    cz: {
        releaseDate: 'zveřejněno',
        moreInfo: 'více informací',
        show: 'Zobrazit',
    },
    sk: {
        releaseDate: 'zverejnené',
        moreInfo: 'viac informácií',
        show: 'Zobraziť',
    },
}
